import { Badge } from "@devhop/ui";

export type SessionInstructorRole = "lead" | "assist" | string;

/** Badges: ຫຼັກ / TA / ສອນແທນ (substitute is separate from TA). */
export function SessionInstructorRoleBadges({
  role,
  isSubstitute,
}: {
  role?: SessionInstructorRole | null;
  isSubstitute?: boolean | null;
}) {
  return (
    <>
      {role === "assist" ? (
        <Badge variant="outline" className="border-sky-500/40 text-sky-700">
          TA
        </Badge>
      ) : role === "lead" ? (
        <Badge variant="outline" className="border-emerald-500/40 text-emerald-700">
          {"\u0eab\u0ebc\u0eb1\u0e81"}
        </Badge>
      ) : null}
      {isSubstitute ? (
        <Badge
          variant="outline"
          className="border-amber-500/40 text-amber-700"
        >
          {"\u0eaa\u0ead\u0e99\u0ec1\u0e97\u0e99"}
        </Badge>
      ) : null}
    </>
  );
}
